<script>
  import _ from 'underscore'

  export default {
    components: {},
    props: {},

    data () {
      return {
        currentPath: this.$route.path,
        splitters: [
          '\uFF5E',    // "?" (FULLWIDTH TILDE)
          '\u301C',    // "?" (WAVE DASH)
          '\uFF3B',    // "?" (FULLWIDTH LEFT SQUARE BRACKET)
        ],
      }
    },

    computed: {
      /**
       * @return {Array<{group:string, path:string, name:string}>}
       */
      availableRoutes () {
        const routes = this.$router.options.routes || []
        return _.where(routes, { capability: 1 })
      },

      /**
       * @return {Array<{label:string, routes:Array<{group:string, path:string, name:string}>}>}
       */
      availableRoutesGroups () {
        const routes = this.availableRoutes
        const groups = _.chain(routes).pluck('group').uniq().compact().value()
        return groups.map(group => ({
          label: group,
          routes: _.where(routes, { group }),
        }))
      },

      currentPage () {
        const { currentPath, availableRoutes } = this
        return _.findWhere(availableRoutes, { path: currentPath }) || {}
      },

      currentPageName () {
        const name = this.currentPage.name || ''
        const found = _.chain(this.splitters)
          .filter(splitter => name.includes(splitter))
          .map(splitter => this.lefthand(name, splitter))
          .first()
          .value()
        return found || name
      },

      currentPageSubName () {
        const name = this.currentPage.name || ''
        const found = _.chain(this.splitters)
          .filter(splitter => name.includes(splitter))
          .map(splitter => splitter + this.righthand(name, splitter))
          .first()
          .value()
        return found || ''
      },
    },

    watch: {
      '$route' (route) {
        this.currentPath = route.path
      },

      currentPath (path) {
        this.$router.push(path)
      },
    },

    created () {
    },

    mounted () {
    },

    beforeDestroy () {
    },

    methods: {
    },

    filters: {
    },
  }
</script>


<template>
  <span class="PageChooser">
    <b>{{ currentPageName }}<small v-if="currentPageSubName">{{ currentPageSubName }}</small></b>
    <select v-model="currentPath">
      <optgroup v-for="group in availableRoutesGroups" :label="group.label" :key="group.label">
        <option v-for="route in group.routes" :value="route.path" :key="route.path">{{ route.name }}</option>
      </optgroup>
    </select>
  </span>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  .PageChooser {
    position: relative;
    display: inline-block;
    margin: 0;
    padding: 0;
    vertical-align: middle;

    & > b {
      pointer-events: none;
      display: inline-flex;
      flex-direction: row;
      align-items: center;
      justify-items: space-between;
      margin: 0;
      padding: 0;
      white-space: nowrap;

      &::after {
        margin: 0.2em 0 0;
        padding: 0 0.5em;
        font-size: 50%;
        font-weight: normal;
        content: "▼"
      }

      small {
        margin: 0.1em 0 0 0.25em;
        padding: 0;
        font-size: $size-unit * 5;
      }
    }

    & > select {
      opacity: 0;
      appearance: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      border: none;
      font: inherit;
      font-size: 1rem;
      line-height: normal;
      color: inherit;
      background: transparent;
      cursor: pointer;
    }
  }
</style>
